import ServerDirections from '@/config/server-directions'
import { RequestService } from '@/services/request.service'
import moment from 'moment'
import { Account } from '@/entities/Account'
const requestService = new RequestService()

export class AccountsRequests {
  getAccount (id) {
    const route = ServerDirections.ACCOUNTS + id
    const method = 'get'
    function map (data) {
      return new Account(data)
    }
    return requestService.makePromise(route, method, {}, map)
  }

  getTransactions (filters) {
    const { limit, offset, accountIds, currencyIds } = filters

    const route = ServerDirections.TRANSACTIONS
    const method = 'get'
    function map (data) {
      var transactions = data.data.map(function (item) {
        return {
          amount: item.transaction.amount,
          created: moment(item.transaction.created).local().format('DD/MM/YYYY HH:mm'),
          station: item.station ? item.station.name : null,
          currencyId: item.transaction.currency_id,
        }
      })
      return {
        transactions: transactions,
        hasNext: data.meta.has_next,
      }
    }
    var params = {
      limit, offset,
    }
    if (accountIds) {
      params.account_ids = accountIds.toString() || []
    }
    if (currencyIds) {
      params.currency_ids = currencyIds.toString() || []
    }
    params.order = 'DESC'
    return requestService.makePromise(route, method, { params }, map)
  }
}
